export const FOUNDER_USER_ID = "user_39PJqHGixeZx9nmFxe4WmdqCos2";

export function isFounderUser(userId?: string | null): boolean {
  return userId === FOUNDER_USER_ID;
}

export function FounderAvatarRing({
  isFounder,
  children,
}: {
  isFounder: boolean;
  children: React.ReactNode;
}) {
  if (!isFounder) return <>{children}</>;
  return (
    // self-start prevents the ring from being vertically stretched when used
    // as a flex-child beside a taller text column (e.g. ComposeModal body).
    <div className="founder-ring self-start">
      <div className="founder-ring-gap">
        {children}
      </div>
    </div>
  );
}
